module.exports = __webpack_public_path__ + "img/calender.6ae7e634.png";